import { render, staticRenderFns } from "./Kcgl.vue?vue&type=template&id=5d9990d6&scoped=true&"
import script from "./Kcgl.vue?vue&type=script&lang=js&"
export * from "./Kcgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9990d6",
  null
  
)

export default component.exports